import PurpleRadialGradientBackground from "@/components/background/purple-radial-gradient";
import { StepsButtons } from "@/components/button/steps-button";
import { LabelStripe } from "@/components/label-stripe";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { cn } from "@/utils/cn";
import { useState } from "react";
import { BrandImage } from "../../components/brand-image";
import { OnboardingPageContainer } from "../../components/containers/onboarding-page-container";
import { FavouriteBrandsModal } from "../../components/modal/favourite-brands-modal";
import { OnboardingFadeContent } from "../../components/onboarding-fade-content";

const brands = [
  { name: "M&S", logo: "/assets/icons/brands/ms.svg" },
  { name: "Gail's", logo: "/assets/icons/brands/gails.png" },
  { name: "Pizza Express", logo: "/assets/icons/brands/pizza-express.svg" },
  { name: "Itsu", logo: "/assets/icons/brands/itsu.svg" },
  { name: "Protein Works", logo: "/assets/icons/brands/protein-works.svg" },
  { name: "Cook", logo: "/assets/icons/brands/cook.svg" },
  { name: "MyProtein", logo: "/assets/icons/brands/my-protein.svg" },
  { name: "Hawksmoor", logo: "/assets/icons/brands/hawksmoor.svg" },
  { name: "Pret A Manger", logo: "/assets/icons/brands/pret.svg" },
  {
    name: "Joe & The Juice",
    logo: "/assets/icons/brands/joe-the-juice.png",
  },
  { name: "The Ivy", logo: "/assets/icons/brands/the-ivy.svg" },
  { name: "Dishoom", logo: "/assets/icons/brands/dishoom.svg" },
  { name: "Paul", logo: "/assets/icons/brands/paul.png" },
  { name: "Proper", logo: "/assets/icons/brands/proper.png" },
  { name: "Mallow & Marsh", logo: "/assets/icons/brands/mallow-and-marsh.png" },
  { name: "Yo! Sushi", logo: "/assets/icons/brands/yoi.svg" },
  { name: "Blank Street", logo: "/assets/icons/brands/blank-street.jpg" },
  { name: "Huel", logo: "/assets/icons/brands/huel.svg" },
];

const OnboardingFavouriteBrands = () => {
  const { navigateToNextStep } = useStepRouteInfo();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <OnboardingPageContainer title="Your Favourite Brands">
      <OnboardingFadeContent className="flex w-full flex-1 flex-col items-center">
        <LabelStripe
          text="All on plan!"
          className="mt-9 flex min-h-11 items-center justify-center"
          textClassName="uppercase tracking-wider"
        />

        <PurpleRadialGradientBackground
          classNames={{
            container: cn("flex-1 w-full flex flex-col items-center"),
            image: cn("bottom-0"),
          }}
        >
          <div className="grid grid-cols-3 gap-2">
            {brands.map((brand) => (
              <BrandImage
                key={brand.name}
                name={brand.name}
                logo={brand.logo}
                onClick={() => setIsModalOpen(true)}
              />
            ))}
          </div>
        </PurpleRadialGradientBackground>

        <StepsButtons type="button" onClick={navigateToNextStep} />

        <FavouriteBrandsModal
          isOpen={isModalOpen}
          onDismiss={() => setIsModalOpen(false)}
          onConfirm={() => setIsModalOpen(false)}
        />
      </OnboardingFadeContent>
    </OnboardingPageContainer>
  );
};

export default OnboardingFavouriteBrands;
